// extracted by mini-css-extract-plugin
export default {"container":"ChargingProfileTabsSkeleton_container__K7-Vw","tab":"ChargingProfileTabsSkeleton_tab__R9SZO","text":"ChargingProfileTabsSkeleton_text__TYTL-"};